export default __webpack_public_path__ + "static/media/Insvestmentwebservicesbg.9ef45c1a.svg";